import request from "@/utils/request";

// 获取关于我们
export function getAboutUs(params) {
  return request({
    url: "/setting/platform-info/list",
    method: "get",
    params
  });
}